import { useRouter } from 'next/router'
import { useEffect } from 'react'
import { collectionPaths, orderAheadBagIdHeader } from '../constants'
import { getCollectionPath } from '#src/common/lib/get-collection-path'
import { useCookie } from 'react-use'

export const useRequireBag = (isTransactional = true, redirectUrl?) => {
  const [bagId] = useCookie(orderAheadBagIdHeader)
  const router = useRouter()
  const { locale } = router
  const collectionPath = getCollectionPath(locale)
  const shouldRedirect = isTransactional && !bagId

  useEffect(() => {
    if (shouldRedirect) {
      router.push(
        redirectUrl ||
          `/${locale}/${collectionPath}/${collectionPaths['select-store']}`
      )
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return { shouldRedirect }
}
